export const selectStyle = {
	valueContainer: (provided) => ({
		...provided,
		paddingLeft: 8,
		paddingRight: 8,
	}),
	placeholder: (provided) => ({
		...provided,
		color: "hsl(0, 0%, 70%)",
		paddingLeft: 4,
		paddingRight: 4,
	}),
	dropdownIndicator: (provided) => ({
		...provided,
		color: "#2B2830",
	}),
	clearIndicator: (provided) => ({
		...provided,
		color: "#2B2830",
	}),
	multiValue: (provided) => ({
		...provided,
		backgroundColor: "hsl(0, 0%, 93%)",
	}),
	multiValueLabel: (provided) => ({
		...provided,
		paddingLeft: 8,
	}),
	option: (provided, state) => ({
		...provided,
		color: "hsl(0, 0%, 5%)",
		backgroundColor: state.isSelected ? "#fad9b8" : provided.backgroundColor,
	}),
};

export const selectTheme = (theme) => ({
	...theme,
	borderRadius: 3,
	colors: {
		...theme.colors,
		primary25: "#fdf3e8",
		primary50: "#fad9b8",
		primary75: "#f4b26f",
		primary: "#ed8113",
		neutral20: "#c1c1c1",
	},
	spacing: {
		...theme.spacing,
		controlHeight: 46,
	},
});
